import { Task } from "src/types/snugtotal";

/**
 * Resolve the human-readable title for an estate document task.
 *
 * The actual estate document type (and its joint_trust flag) is the source of
 * truth. The household "estate plan foundation" (EPF) — which drives
 * `task.title` — can diverge from the real document (e.g. EPF = joint_trust but
 * the document is actually a Will), so deriving the title by string-matching on
 * `task.title` produces the wrong label. Prefer `task.estateDocument.type` and
 * only fall back to the EPF-derived title for placeholder states where no
 * document exists yet (e.g. "Choose a Will or Trust", "Upload from Attorney").
 */
export const getDocumentTitle = (task: Task): string => {
  switch (task.estateDocument?.type) {
    case "TRUST":
      return task.estateDocument?.joint_trust
        ? "Joint Revocable Living Trust"
        : "Living Trust";
    case "WILL":
      return "Last Will & Testament";
    case "FINANCIAL_POWER_OF_ATTORNEY":
      return "Financial Power of Attorney";
    case "HEALTHCARE_DIRECTIVE":
      return "Health Care Directive";
    case "ASSETS":
      return "Asset Planning";
  }

  // No document yet → fall back to the EPF-derived task title (placeholder states).
  if (task.kind === "lwt") {
    if (task.title.includes("Joint")) return "Joint Revocable Living Trust";
    if (task.title.includes("Will")) return "Last Will & Testament";
    return "Living Trust"; // "Living Trust", "Choose…", "Upload…" placeholders
  }
  if (task.kind === "fpoa") return "Financial Power of Attorney";
  if (task.kind === "hcd") return "Health Care Directive";
  if (task.kind === "assets") return "Asset Planning";
  return task.title;
};
